<template>
  <baby-status-face
    :initialValue="state"
    :student="studentName"
    :title="title"
    @updatedElement="propagateChange"
    ref="element" />
</template>
<script>
import BabyStatusFace from './BabyStatusFace.vue'

export default {
  components: { BabyStatusFace },
  created: function () {
    this.state = this.$attrs.student ? this.$attrs.student.secondCourse : this.byDefault
  },
  props: {
    initialValue: String,
    title: {
      type: String,
      default: () => '2º Plato'
    },
    studentName: String
  },
  data: () => ({
    enabled: false,
    byDefault: 'todo',
    state: ''
  }),
  methods: {
    setValue: function (value) {
      this.state = value
      this.$refs.element.setValue(value)
    },
    setEnable: function (value) {
      this.enabled = value
      this.$refs.element.setEnable(value)
      this.enabled ? this.setValue(this.byDefault) : this.setValue('ausente')
    },
    propagateChange: function (item) {
      this.$emit('updatedElement',
        { secondCourse: item.value }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/diaryElements/SecondCourse.vue